import React from 'react';

import { useIntl } from 'react-intl';

import { IBaseProps } from '@rbi-ctg/frontend';
import { AllergenContainsEnum, IAllergenDto } from 'generated/graphql-gateway';

import { AllergenNames, AllergensDisclaimerContainer } from './styled';
import {
  ALLERGEN_CONTAINS_ENUM_TO_NUMBER,
  ALLERGEN_GROUP_TYPE_TO_PARAM_ID,
  AllergensType,
  COMBINATION_TO_DISCLAIMER_ID,
} from './types';

interface IAllergensDisclaimerProps extends IBaseProps {
  allergens: IAllergenDto | undefined;
}

export const AllergensDisclaimer: React.FC<React.PropsWithChildren<IAllergensDisclaimerProps>> = ({
  allergens,
}) => {
  const { formatMessage } = useIntl();

  if (!allergens) {
    return null;
  }

  const combination = [0, 0, 0];

  // Build parameters object while determining the string combination to use
  const parameters: { [key in AllergensType]: string[] } = {
    allergens: [],
    maybeAllergens: [],
    maybeCookedOnAllergens: [],
  };

  // Populate allergen groups.
  const allergenKeys = Object.keys(allergens);
  for (const key of allergenKeys) {
    if (key === '__typename') {
      continue;
    }
    const allergenValue = allergens[key as keyof IAllergenDto] as AllergenContainsEnum;
    const parameterId = ALLERGEN_GROUP_TYPE_TO_PARAM_ID[allergenValue];
    if (parameterId) {
      const idx = ALLERGEN_CONTAINS_ENUM_TO_NUMBER[allergenValue] - 1;
      combination[idx] = 1;
      parameters[parameterId].push(key);
    }
  }

  // Join allergen groups to be displayed
  const styledAllergenGroups: Partial<{ [key in AllergensType]: React.ReactNode }> = {};
  for (const key in parameters) {
    if (parameters[key as AllergensType].length > 0) {
      styledAllergenGroups[key as AllergensType] = (
        <AllergenNames>{parameters[key as AllergensType].join(', ')}</AllergenNames>
      );
    }
  }

  // Retrieve string ID from combination of allergen groups.
  const combinationId = combination.join('');
  const id = COMBINATION_TO_DISCLAIMER_ID[combinationId] || 'allergensDisclaimerUnknown';

  return (
    <AllergensDisclaimerContainer testID="allergens-disclaimer">
      {formatMessage({ id }, styledAllergenGroups)}
    </AllergensDisclaimerContainer>
  );
};
